module.exports = __webpack_public_path__ + "img/boneca03.5dc1ae4d.png";